import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SaveButton extends Component {
  constructor(props) {
    super(props);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  handleSaveClick() {
    const {suggestedOrders, provider, loading} = this.props;

    if (loading) {
      return;
    }

    if (!suggestedOrders.length) {
      this.props.addMessageBoxWarning('No se puede guardar un avance sin pedidos');
      return;
    }

    const elementsToDelete = suggestedOrders.filter((element) => element.deleted);
    const elementsToProcess = suggestedOrders.filter((element) => !element.deleted);
    const orderInfo = {
      provider,
      'orderCode': suggestedOrders[0].orderCode,
      'orders': elementsToProcess,
    };

    if (elementsToDelete.length) {
      const sanitizedOrdersToDelete = elementsToDelete.map((order) => {
        return {...order, 'partCode': order.oldCode || order.partCode};
      });
      this.props.deleteProviderStockOrderPart(orderInfo, sanitizedOrdersToDelete, true);
      return;
    }

    this.props.processProviderStockOrder(orderInfo, true);
  }

  render() {
    const {loading, consulted} = this.props;

    if (loading || !consulted) {
      return null;
    }

    return (
      <Button secondary type='button' onClick={this.handleSaveClick}>GUARDAR AVANCE</Button>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingSuggestions, generating} = state.providerStockOrders;

  return {
    'loading': loadingSuggestions || generating,
    'consulted': state.providerStockOrders.consulted,
    'provider': state.providerStockOrders.provider,
    'suggestedOrders': state.providerStockOrders.suggestedOrders,
  };
};

const {
  addMessageBoxWarning,
  processProviderStockOrder,
  deleteProviderStockOrderPart,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxWarning,
  processProviderStockOrder,
  deleteProviderStockOrderPart,
})(SaveButton);
